import { Section } from "@arp/react-ndbx";
import React, { useEffect, useState } from "react";

//** Page-Level Information */
import { titles } from "../../../config/dropdownSelectValues/selectValues";
import { questionLabels } from "../../../config/questions/questionItems.js";

//** Components */
import Page from "../../../components/Page";
import ButtonNavigationGroup from "../../../components/organisms/ButtonNavigationGroup.jsx";
import YourDetailsHeader from "../../../components/pageLevel/YourDetailsHeader.jsx";

//** MUI Components */
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Typography } from "@mui/material";
// import useTheme from "@mui/material/styles/useTheme";

//** Context */
import usePreQualification from "../../../hooks/usePreQualification.ts";
import usePreQualificationPages from "../../../hooks/usePreQualificationPages.ts";
// import useSharedData from "../../../hooks/useSharedData.ts";

import { useOutletContext } from "react-router-dom";

//**  TEST */
import PersonalInformation from "../../../components/pageLevel/personalInformation/PersonalInformation.jsx";

import * as Sentry from "@sentry/react";

export default function YourDetailsPersonal({ insuredPerson }) {
	const {
		errors: [...errors],
		onClick: [onClick],
		showSecond: [showSecond],
		isDirty: [isDirty],
		isValid: [isValid],
		methods: [methods],
	} = useOutletContext();

	const { trigger } = { ...methods };

	useEffect(() => {
		//* We want to validate the page
		//* when we move back on to it.
		//* the valid flag tells us that we have completed this page
		//* and all validation was complete.
		if (currentPage.valid === true) {
			trigger();
		}
	}, [trigger]);

	//* Shared data
	// const { handleEventChange } = useSharedData();

	const { state } = usePreQualificationPages();
	const { dataSet } = usePreQualification();
	const { currentPage } = { ...state };

	// const theme = useTheme();

	//----------------------------------------------------------------

	const [titleItems, setTitleItems] = useState([]);

	useEffect(() => {
		Sentry.captureMessage(
			"Your Details Personal : " + state?.application,
			"info"
		);
		setTitleItems(titles);
		trackifyPageChange(currentPage?.identifier?.toLowerCase());
		// handleEventChange({
		//   name: "isCoverStateValid",
		//   value: false,
		// });
	}, []);

	const handleSecondPerson = () => {
		onClick();
	};

	const iconDisplay = showSecond ? (
		<RemoveCircleIcon sx={{ mr: { xs: 0, md: 1 }, justifyContent: "center" }} />
	) : (
		<AddCircleIcon sx={{ mr: { xs: 0, md: 1 }, justifyContent: "center" }} />
	);
	//----------------------------------------------------------------

	return (
		<Page title={currentPage.title} identifier={currentPage.identifier}>
			<YourDetailsHeader />
			{showSecond === true ? (
				<Section mt={8}>
					<Typography variant="p2-bold">Applicant 1</Typography>
				</Section>
			) : null}
			<Section>
				{dataSet != null ? (
					<PersonalInformation
						person={"personOne"}
						dataSet={dataSet}
						titleItems={titleItems}
						questionLabels={questionLabels}
						errors={errors}
					/>
				) : null}
			</Section>
			<Section>
				<ButtonNavigationGroup showBackButton={false} />
			</Section>
		</Page>
	);
}
